module.exports = {
  clipboard: [ 'type', require(148) ]
};
